import React, { Dispatch } from 'react';
import { NotificationsActions } from '../../app/common/notifications/notificationsActions';
import { memberUpdateProfile } from './personalInfo.service';
import { ErrorResolutionActions } from '../../app/common/errorResolution/errorResolutionActions';
import { TranslationHelpers } from '../../i18n/translationHelpers';
import { loginActions } from '../../login/login.actions';
import { IPersonalInfoResponse, IUpdateMemberInfo } from './personalInfo.interface';
import { PersonalInfoAction, PersonalInfoActionTypes } from './personalInfoActionType';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import { ClientConfig } from '../../app/appState.interface';
import { ThunkDispatch } from 'redux-thunk';
import {
    ErrorResolution,
    ErrorResolutionTypes,
} from '../../app/common/errorResolution/errorResolution';
import ErrorRedirectService from '../../routes/error/errorRedirect.service';

export const personalInfoActions = {
    updateMemberInfo,
};

function updateMemberInfo(data: IUpdateMemberInfo) {
    return (
        dispatch: ThunkDispatch<IReduxRootState, {}, PersonalInfoAction>,
        getState: () => IReduxRootState,
    ) => {
        const initialMemberInfo = getState().member;
        const clientConfig: ClientConfig = getState().app.clientConfig;
        data.clientId = getState().app.clientConfig.clientId;
        dispatch(memberUpdateRequest());
        memberUpdateProfile(data)
            .then((response) => {
                const updatedFields = Object.keys(response).filter((param) => {
                    return response[param] !== initialMemberInfo[param];
                });
                dispatch(memberUpdateSuccess(response, clientConfig, updatedFields));
                dispatch(loginActions.getMember());

                if (response.dob) {
                    dispatch(dobSet(response.dob));
                }
            })
            .catch((errorResolution) => {
                memberUpdateFailure(dispatch, errorResolution, data);
            });
    };

    function memberUpdateRequest(): PersonalInfoAction {
        return { type: PersonalInfoActionTypes.UPDATE_REQUEST };
    }

    function memberUpdateFailure(
        dispatch: Dispatch<PersonalInfoAction | NotificationAction>,
        errorResolution: ErrorResolution,
        updateMemberInfo: IUpdateMemberInfo,
    ) {
        const data = updateMemberInfo as any;
        if (errorResolution.type === ErrorResolutionTypes.RE_AUTH) {
            ErrorRedirectService.reAuth();
        } else {
            dispatch(
                ErrorResolutionActions.processErrorResolution(
                    errorResolution,
                    'notifications.personalInformation.update.failure',
                    { challengerPid: data.challengeData?.cpid },
                ),
            );
        }

        dispatch({
            payload: {},
            type: PersonalInfoActionTypes.UPDATE_FAILURE,
        });
    }

    function memberUpdateSuccess(
        memberInfo: IPersonalInfoResponse,
        clientConfig: ClientConfig,
        updatedFields: string[],
    ): any {
        const ratObject = clientConfig
            ? {
                  pData: {
                      ratPageName: 'Personal information',
                  },
                  cpData: {
                      Updated_fields: updatedFields,
                  },
              }
            : {};
        return (dispatch: Dispatch<PersonalInfoAction>) => {
            dispatch(
                NotificationsActions.showSuccess(
                    TranslationHelpers.getFormattedMessage(
                        'notifications.personalInformation.update.success',
                    ),
                ),
            );
            dispatch({
                type: PersonalInfoActionTypes.UPDATE_SUCCESS,
                memberInfo,
                clientConfig,
                meta: {
                    rat: ratObject,
                },
            });
        };
    }

    function dobSet(date: string): PersonalInfoAction {
        localStorage.setItem('setDob', date);
        return { type: PersonalInfoActionTypes.DOB_SET, date };
    }
}
